/** Client-side patch application for agent copilot (mirrors backend). */
export function applyManualPatches(content, patches) {
  const out = JSON.parse(JSON.stringify(content));
  for (const patch of patches || []) {
    if (patch.op === 'set' && patch.path) {
      setByPath(out, patch.path, patch.value);
    } else if (patch.op === 'add' && patch.path) {
      const arr = getByPath(out, patch.path);
      if (Array.isArray(arr) && patch.value) arr.push(patch.value);
    }
  }
  return out;
}

export function applyDocumentPatches(form, patches) {
  const next = { ...form };
  for (const patch of patches || []) {
    if (patch.op === 'set' && patch.field) {
      next[patch.field] = patch.value;
    }
  }
  return next;
}

function getByPath(obj, pathStr) {
  const parts = pathStr.replace(/\[(\d+)\]/g, '.$1').split('.').filter(Boolean);
  let cur = obj;
  for (const p of parts) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

function setByPath(obj, pathStr, value) {
  const parts = pathStr.replace(/\[(\d+)\]/g, '.$1').split('.').filter(Boolean);
  let cur = obj;
  for (let i = 0; i < parts.length - 1; i++) {
    const p = parts[i];
    if (cur[p] == null) cur[p] = /^\d+$/.test(parts[i + 1]) ? [] : {};
    cur = cur[p];
  }
  cur[parts[parts.length - 1]] = value;
}